// one-state-screenpop/model.ts
/**
 * Represents the one-state-screenpop modal
 */
 export const enum ScreenPopFrom {
    SLIDER_MENU = "2005",
    DASHBOARD_TAB = "2006",
    APPOINTMENTS_TAB = "2007",
    REFERRALS_TAB = "2008",
    BILLING_TAB = "2009",
    SUBJECT_CARD = "2010"
};
export interface ScreenpopModel {
    agentId?: string;
    location?: string;
    patientId?: string;
    activityId?: string;
    eventType?:string;
    status?:string;
    from?: ScreenPopFrom

}
